import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import {
  Paper,
  Typography,
  Grid,
  Box,
  Button,
  InputAdornment,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  Alert,
  Avatar,
  TextField,
  Snackbar,
  useTheme,
  useMediaQuery,
  Menu,
  MenuItem,
} from "@mui/material";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import formFields from "./FormFields.json";
import additionalFields from "./AdditionalFields.json";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ApiCallService from "../../../../../Service/ApiCallService";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../../../components/common/Spinner";
import CustomTextField from "../../../../../components/common/CustomTextField";
import CustomSelect from "../../../../../components/common/CustomSelect";
import CustomDatePicker from "../../../../../components/common/CustomDatePicker";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit"
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AssignmentsTab from "./AssignmentsTab";
import useAssignments from "./useAssignments";
import { usePermission } from "../../../../../permissions/usePermission";
import { updateUserDetails } from "../../../../../features/user/UserSlices";
import { message } from "antd";
import certificateTemplate from "../../../../../assets/certificates/officeBearerCertificateBk_nw_updated.png";
import {
  buildCertificateCanvas,
  downloadCanvasAsPdf,
  getEligibleCertificateOptions,
  resolveStatePresidentDetails,
  sanitizeFileSegment,
} from "./certificateUtils";
import { getPublicS3Url } from "../../../../../utils/s3PublicUrl";


// Keep these files in `public/signatures/` (or update paths here)
const FOUNDER_SIGN_PATH = "/signatures/founder-signature.png";
const NATIONAL_PRESIDENT_SIGN_PATH =
  "/signatures/national-president-signature.png";
const NATIONAL_PRESIDENT_NAME = "Nandkishor Sakhala";
const FOUNDER_NAME = "Shantilal Muttha";
const TENURE_TEXT = "2025 & 2026";

const RegistrationFormNewUser = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  let filledBy = null;
  const EMPTY_SCOPE = {
    level: "",
    state: "",
    region: "",
    district: "",
    chapter: "",
    // program: "",
  };

  const SCOPE_LEVELS = [
    { value: "NATIONAL", label: "National" },
    { value: "STATE", label: "State" },
    { value: "REGION", label: "Region" },
    { value: "DISTRICT", label: "District" },
    // { value: "CHAPTER", label: "Chapter" },
    // { value: "PROGRAM", label: "Program" },
  ];
  const [imageURL, setImageURL] = useState("");
  const [imageKey, setImageKey] = useState("");
  const [idURL, setIdUrl] = useState("");
  const [idKey, setIdKey] = useState("");
  const [indiaObject, setIndiaObject] = useState({});
  const [duplicateUsers, setDuplicateUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  let mob = localStorage.getItem("mobileNumber");
  const userIdDetails = useSelector((state) => state.user);

  const [showAlert, setShowAlert] = useState(false);
  const [hasReset, setHasReset] = useState(false);
  const [showCreateAssignments, setShowCreateAssignments] = useState(false);

  // const [loadingCount, setLoadingCount] = useState(0);
  // const startLoading = () => setLoadingCount((c) => c + 1);
  // const stopLoading = () => setLoadingCount((c) => Math.max(c - 1, 0));

  // const loading = loadingCount > 0;

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  // Helper function to show notification
  const showNotification = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const getApiErrorMessage = (err) => {
    const data = err?.response?.data || err?.data || err;

    if (typeof data === "string") return data;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    if (Array.isArray(data?.details) && data.details.length > 0) {
      return data.details
        .map((detail) => detail?.message)
        .filter(Boolean)
        .join(", ");
    }

    return err?.message || "Something went wrong.";
  };

  const closeNotification = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const userData = useSelector((state) => state.user.userDetails);

  // Determine if this is self-service registration before using permissions
  if (userData?.error === "User not found.") {
    filledBy = "SELF";
  } else {
    filledBy = "HO";
  }
  const isSelfService = filledBy === "SELF";

  const { canByKey } = usePermission();

  // For self-service registration, permissions are not needed
  const canApproveUserCreate = isSelfService
    ? false
    : canByKey("USER_MANAGEMENT_USER_APPROVAL_APPROVE_CREATE");
  const canDeclineUserCreate = isSelfService
    ? false
    : canByKey("USER_MANAGEMENT_USER_APPROVAL_DECLINE_CREATE");

  const loggedInUser = localStorage.getItem("userId");

  const [formData, setFormData] = useState({
    salutation: "",
    userFirstName: "",
    userImageURL: "",
    userDocumentVerifyURL: "",
    userMiddleName: "",
    userLastName: "",
    whatsAppNumber: "",
    mobileNumber: mob || "",
    sameAsMobileNumber: false,
    // alternateNumber: "",
    // address: "",
    profession: "",
    pinCode: "",
    maritalStatus: "",
    education: "",
    // bjsConnectProfileID: "",
    userJoinDate: "",

    village: "",
    country: "676a5efa74f99238834a5c4c",
    state: "",
    district: "",
    region: "",
    taluka: "",

    filledBy: filledBy,
    filledByUserId: filledBy === "HO" ? userIdDetails.userId : null,
  });

  const navigate = useNavigate();
  const { id } = useParams();
  const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
  const path = location.pathname;
  const isDastak = path.includes("/dastak");
  const isDastakProfilePage = path.startsWith("/dastak/profile/");
  const addNewChapterMember = canByKey(
    "CHAPTER_MANAGEMENT_CHAPTERS_MEMBERS_CREATE",
  ); //key to redirect to /addChapterMember url
  const canViewAssignments = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_LIST",
  );
  const canAssignCommittees = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_ASSIGN",
  );
  const canUpdateCommitteeMemberRole = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_UPDATE_ROLE",
  );
  const canUpdateCommitteeMemberDetails = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_UPDATE",
  );
  const canFilterCommitteeMembers = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_FILTER",
  );
  const canSearchCommitteeMembers = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_SEARCH",
  );
  const canRemoveCommitteeAssignment = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_ROLES_DELETE",
  );
  const isChapterMemberPage = location.pathname.includes("addChapterMember");
  const shouldHideAssignmentsTab = addNewChapterMember && isChapterMemberPage;
  const shouldShowAssignmentsTab =
    !isDastakProfilePage &&
    path !== "/registerNewUser" && canViewAssignments;
  const canEditAssignments = canAssignCommittees;
  // const mode = location.state?.mode || "create";
  const [mode, setMode] = useState(
    location?.state?.mode ||
      (shouldHideAssignmentsTab
        ? "create"
        : path.includes("/committee/registerNewUser") ||
            path.includes("/registerNewUser")
          ? "create"
          : "update"),
  );
  const routeNavigatedFrom = location.state?.navigateFrom || "";
  const navigationSourceStorageKey = `registrationFormNavigateFrom:${id || "new"}`;
  const navigationSourceRef = useRef(
    routeNavigatedFrom ||
      sessionStorage.getItem(navigationSourceStorageKey) ||
      "",
  );
  if (routeNavigatedFrom) {
    navigationSourceRef.current = routeNavigatedFrom;
  }
  const navigatedFrom = navigationSourceRef.current;

  useEffect(() => {
    if (!routeNavigatedFrom) return;
    sessionStorage.setItem(navigationSourceStorageKey, routeNavigatedFrom);
  }, [navigationSourceStorageKey, routeNavigatedFrom]);
  const [userForVefication, setUserForVefication] = useState({});
  const [lastAssignedUserId, setLastAssignedUserId] = useState(null);
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [statusAction, setStatusAction] = useState("deactivate");
  const [statusReason, setStatusReason] = useState("");
  const [statusLoading, setStatusLoading] = useState(false);

  const isOwnProfile = String(loggedInUser) === String(id);

  const [statusDialogOpenCommittee, setStatusDialogOpenCommittee] =
    useState(false);
  const [statusReasonCommittee, setStatusReasonCommittee] = useState("");
  const [certificateLoading, setCertificateLoading] = useState(false);
  const [certificateDialogOpen, setCertificateDialogOpen] = useState(false);
  const [selectedCertificateOptionKey, setSelectedCertificateOptionKey] =
    useState("");
  const [certificatePreviewUrl, setCertificatePreviewUrl] = useState("");
  const [certificatePreviewLoading, setCertificatePreviewLoading] =
    useState(false);
  const [certificatePreviewScale, setCertificatePreviewScale] = useState(1.5);
  const normalizedNavigatedFrom = String(navigatedFrom || "")
    .trim()
    .replace(/^\/+/, "")
    .toLowerCase();
  const isCommitteeMembersListSource = normalizedNavigatedFrom.endsWith(
    "committeememberslist",
  );
  const isUsersListSource = normalizedNavigatedFrom.endsWith("userslist");
  const deactivateCommitteeMemberLabel = isCommitteeMembersListSource
    ? "Deactivate Committee Member"
    : "Deactivate User";
  const deactivateUserLabel = "Deactivate User";
  const isViewAccountSource =
    normalizedNavigatedFrom === "viewaccount" ||
    normalizedNavigatedFrom.endsWith("/viewaccount");
  const navigationSourceSegments = normalizedNavigatedFrom
    .split("/")
    .filter(Boolean);
  const isUsersApprovalsSource =
    normalizedNavigatedFrom === "usersapprovals";
  const isDesignationUsersApprovalsSource =
    navigationSourceSegments.length >= 2 &&
    navigationSourceSegments.at(-1) === "usersapprovals";
  const getEmptyFormValues = () => ({
    salutation: "",
    userFirstName: "",
    userImageURL: "",
    userDocumentVerifyURL: "",
    userMiddleName: "",
    userLastName: "",
    mobileNumber: mode === "create" && isSelfService ? mob : "",
    // mobileNumber:
    //   path === `${isSuperAdmin}/committee/registerNewUser` // || path === "/registerNewUser"
    //     ? ""
    //     : mob,
    whatsAppNumber: "",
    sameAsMobileNumber: false,
    // address: "",
    city: "",
    emailId: "",
    gender: "",
    // dob: "",
    profession: "",
    pinCode: "",
    maritalStatus: "",
    education: "",
    // bjsConnectProfileID: "",
    JoinedSince: "",
    village: "",
    country: "676a5efa74f99238834a5c4c",
    state: "",
    region: "",
    district: "",
    taluka: "",
  });
  const {
    councils,
    chapters,
    programs,
    scopeRegionsByState,
    scopeDistrictsByState,
    committeeRows,
    setCommitteeRows,
    authorityType,
    setAuthorityType,
    authorityOpen,
    setAuthorityOpen,
    assignmentErrors,
    setAssignmentErrors,
    runAssignments,
    syncUserAssignments,
    clearCommitteeAssignments,
    clearChapterAssignments,
    clearProgramAssignments,
    handleCouncilChange,
    handleCommitteeStateChange,
    handleCommitteeRegionChange,
    handleCommitteeDistrictChange,
    handleCommitteeSubtypeChange,
    handleCommitteeChange,
    handleDesignationChange,
    handleScopeChange,
    handleRemoveCommittee,
    handleAddCommitteeRow,
    userExistingChapterAssignments,
    userAssignments,
    openAssignmentModal,
    setOpenAssignmentModal,
    selectedChapter,
    addChapterAssignments,
    handleAddChapterAssignments,
    EXISTING_ASSIGNMENT_COLUMNS,
    EXISTING_ASSIGNMENT_ROWS,
    chapterRows,
    programRows,
    programBaskets,
    CHAPTER_ROLE_OPTIONS,
    TESTcolumns,
    handleAddProgramRow,
    handleRemoveProgramRow,
    handleProgramBasketChange,
    handleProgramSelectionChange,
    handleProgramScopeChange,
    handleChapterScopeChange,
    resetAssignmentsForCreate,
    validateAssignments,
    hasAssignmentChanges,
    recordInitialCommitteeMemberships,
  } = useAssignments({
    id,
    mode,
    path,
    emptyScope: EMPTY_SCOPE,
    showNotification,
  });

  // react-hook-form setup
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "onChange", // as soon as any changes are made in the input field
    // mode: "onBlur", // as soon as focus shifts
    // mode: "onSubmit", // only when we submit.
    defaultValues: {
      salutation: "",
      userFirstName: "",
      userImageURL: "",
      userDocumentVerifyURL: "",
      userMiddleName: "",
      userLastName: "",
      mobileNumber: mode == "create" ? "" : mob,
      // mobileNumber:
      //   path === "/committee/registerNewUser" || path === "/registerNewUser"
      //     ? mob
      //     : "",
      whatsAppNumber: "",
      sameAsMobileNumber: false,
      // alternateNumber: "",
      // address: "",
      city: "",
      emailId: "",
      gender: "",
      // dob: "",
      profession: "",
      pinCode: "",
      maritalStatus: "",
      education: "",
      // bjsConnectProfileID: "",
      JoinedSince: "",
      village: "",
      country: "676a5efa74f99238834a5c4c",
      state: "",
      region: "",
      district: "",
      taluka: "",
    },
  });

  const stateValue = watch("state");
  const regionValue = watch("region");
  const districtValue = watch("district");
  const talukaValue = watch("taluka");
  const pinCodeValue = watch("pinCode");
  const sameAsMobile = watch("sameAsMobileNumber");
  const prevStateRef = useRef("");
  const prevRegionRef = useRef("");
  const prevDistrictRef = useRef("");
  const prevTalukaRef = useRef("");
  const validateMobile = (v) => /^[0-9]{10}$/.test(v);
  const validateEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  const validateProfession = (v) => /^[A-Za-z\s]+$/.test(v);
  const validatePincode = (v) => /^\d{6}$/.test(v);
  const pinLookupDebounceRef = useRef(null);
  const pinLookupAbortRef = useRef(null);
  const pinLookupRequestIdRef = useRef(0);
  const pincodeLookupRef = useRef({
    lastFetched: "",
  });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleBack = () => {
    navigate(-1);

    if (location.state?.mode) {
      setMode(location.state.mode);
    }
  };

  //   useEffect(() => {
  //   if (!designation) return;

  //   // dispatch(fetchDesignationPolicy(designation));
  // }, [designation]);

  useEffect(() => {
    if (location.state?.mode) {
      setMode(location.state.mode);
    }
  }, [location?.state?.mode]);

  const canActivateUser = isSelfService
    ? false
    : canByKey("USER_MANAGEMENT_USER_STATUS_ACTIVATE");
  const canDeactivateUser = isSelfService
    ? false
    : canByKey("USER_MANAGEMENT_USER_STATUS_DEACTIVATE");

  const canManageStatusInView =
    mode === "view" &&
    Boolean(id) &&
    isUsersListSource &&
    userForVefication?.verified === "verified";

  const canShowStatusAction =
    canManageStatusInView &&
    ((userForVefication?.userStatus === "active" && canDeactivateUser) ||
      (userForVefication?.userStatus !== "active" && canActivateUser));
  const isUserVerified = userForVefication?.verified === "verified";
  const assignmentTargetUserId = id || lastAssignedUserId;
  const canAddAssignmentsInCreate =
    mode === "create" &&
    shouldShowAssignmentsTab &&
    !shouldHideAssignmentsTab &&
    canEditAssignments;
  const canAccessAssignmentsSection =
    shouldShowAssignmentsTab &&
    !shouldHideAssignmentsTab &&
    isUserVerified &&
    (mode !== "create" || Boolean(assignmentTargetUserId));
  const shouldRenderAssignmentsSection =
    canAccessAssignmentsSection ||
    (canAddAssignmentsInCreate && showCreateAssignments);

  const canEditUser = isSelfService
    ? false
    : canByKey("USER_MANAGEMENT_USERS_EDIT");
  const canViewJourney = isSelfService
    ? false
    : canByKey("USER_MANAGEMENT_USER_JOURNEY_VIEW");
  const canUnassignCommitteeMembership = canByKey(
    "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_UNASSIGN",
  );
  const canShowHeaderUserStatusAction =
    isUsersListSource && canShowStatusAction;
  const canShowHeaderCommitteeDeactivation =
    !isUsersListSource &&
    !isDesignationUsersApprovalsSource &&
    !isViewAccountSource &&
    canUnassignCommitteeMembership;

  const openStatusDialog = (action) => {
    setStatusAction(action);
    setStatusReason("");
    setStatusDialogOpen(true);
  };

  const handleEdit = () => {
    setMode("update");
  };

  const handleViewJourney = () => {
    const viewedUserId = id || userForVefication?._id;
    if (!viewedUserId) return;

    const viewedUserJourney = Array.isArray(userForVefication?.journey)
      ? userForVefication.journey
      : [];

    navigate(`/journey?layout=horizontal&userId=${viewedUserId}`, {
      state: {
        layout: "horizontal",
        userId: viewedUserId,
        journeyData: viewedUserJourney,
      },
    });
  };

  const handleDeactivateCommitteeMemberships = () => {
    setStatusReasonCommittee("");
    setStatusDialogOpenCommittee(true);
  };

  const handleStatusActionConfirm = async () => {
    if (!id) return;
    try {
      setStatusLoading(true);
      const userEndpoint =
        statusAction === "deactivate"
          ? `${process.env.REACT_APP_BASE_URL}/user/deactivate/${id}`
          : `${process.env.REACT_APP_BASE_URL}/user/reactivate/${id}`;

      await ApiCallService.patch(userEndpoint, {
        reason: statusReason,
        userId: loggedInUser,
      });

      showNotification(
        statusAction === "deactivate"
          ? "User deactivated successfully."
          : "User reactivated successfully.",
        "success",
      );
      setStatusDialogOpen(false);
      navigate("/usersList");
    } catch (err) {
      showNotification(
        err?.response?.data?.error || err?.error || "Failed to update status.",
        "error",
      );
    } finally {
      setStatusLoading(false);
    }
  };

  const handleCommitteeDeactivationConfirm = async () => {
    if (!id || !statusReasonCommittee.trim()) return;
    try {
      setStatusLoading(true);
      await ApiCallService.patch(
        `${process.env.REACT_APP_BASE_URL}/committeeMembers/deactivateByUser/${id}`,
        {
          reason: statusReasonCommittee,
          userId: loggedInUser,
        },
      );
      showNotification(
        "Committee memberships deactivated successfully",
        "success",
      );
      setStatusDialogOpenCommittee(false);
    } catch (err) {
      showNotification(
        err?.response?.data?.error ||
          err?.error ||
          "Failed to deactivate committee memberships.",
        "error",
      );
    } finally {
      setStatusLoading(false);
    }
  };

  const fetchAllStates = async () => {
    const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/states`);

    const list = res?.data ?? [];
    setStates(list);
    return list;
  };
  const fetchStatesByCountry = async (countryId) => {
    if (!countryId) return [];

    const res = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/country/${countryId}/states`,
    );

    const list = res?.data?.data ?? [];
    setStates(list);
    return list;
  };

  const fetchDistricts = async (selectedState, selectedDistrict) => {
    if (!selectedState) {
      setDistricts([]);
      return;
    }
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/state/${selectedState}/district`,
      );
      const data = res?.data?.data ?? res?.data ?? [];
      setDistricts(Array.isArray(data) ? data : []);
      if (selectedDistrict) {
        // optionally fetch talukas for a pre-selected district
        // await fetchTalukas(selectedDistrict);
      }
    } catch (err) {
      console.error("Error fetching districts:", err);
      setDistricts([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchTalukas = async (selectedDistrict) => {
    if (!selectedDistrict) {
      setTalukas([]);
      return [];
    }
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/district/${selectedDistrict}/taluka`,
      );
      // support res.data.data or res.data
      const data = res?.data?.data ?? res?.data ?? [];
      const arr = Array.isArray(data) ? data : [];
      setTalukas(arr);
      return arr;
    } catch (err) {
      console.error("Error fetching talukas:", err);
      showNotification("Error fetching talukas.", "warning");
      setTalukas([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const fetchVillages = async (selectedTaluka) => {
    if (!selectedTaluka) {
      setVillages([]);
      return [];
    }
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/taluka/${selectedTaluka}/village`,
      );
      let arr = res?.data?.data ?? res?.data ?? [];
      arr = Array.isArray(arr) ? arr : [];

      // Check if current village is in the list
      const currentVillage = getValues("village");
      if (currentVillage && !arr.find((v) => v._id === currentVillage)) {
        const village = await fetchVillageById(currentVillage);
        if (village) {
          arr.push(village);
        }
      }

      setVillages(arr);
      return arr;
    } catch (err) {
      console.error("Error fetching villages:", err);
      showNotification("Error fetching villages.", "warning");
      setVillages([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const fetchVillageById = async (villageId) => {
    if (!villageId) return null;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/village/${villageId}`,
      );
      return res?.data?.data ?? res?.data ?? null;
    } catch (err) {
      console.error("Error fetching village by ID:", err);
      return null;
    }
  };

  const normalizeText = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  const findByName = (list = [], keys = [], target = "") => {
    const normalizedTarget = normalizeText(target);
    if (!normalizedTarget) return null;

    return (
      list.find((item) =>
        keys.some((key) => normalizeText(item?.[key]) === normalizedTarget),
      ) || null
    );
  };

  const autoFillLocationFromPinCode = async (pinCode) => {
    if (!validatePincode(pinCode)) return;
    if (mode === "view") return;
    if (pincodeLookupRef.current.lastFetched === pinCode) return;

    const requestId = ++pinLookupRequestIdRef.current;
    if (pinLookupAbortRef.current) {
      pinLookupAbortRef.current.abort();
    }
    const controller = new AbortController();
    pinLookupAbortRef.current = controller;

    try {
      // Backend endpoint expected to resolve external pincode service and return normalized data.
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/location/pincode/${pinCode}`,
        { signal: controller.signal, timeout: 6000 },
      );
      if (requestId !== pinLookupRequestIdRef.current) return;

      const payload = response?.data?.data ?? response?.data ?? {};
      const stateName = payload?.state || payload?.stateName || "";
      const regionName = payload?.region || payload?.regionName || "";
      const districtName = payload?.district || payload?.districtName || "";
      const talukaName = payload?.taluka || payload?.talukaName || "";
      const villageName = payload?.village || payload?.villageName || "";
      // const cityName = payload?.city || payload?.cityName || "";

      // City field is currently hidden.
      // const nextCity = cityName || villageName || districtName;
      // if (nextCity) {
      //   setValue("city", nextCity, { shouldValidate: true, shouldDirty: true });
      // }

      let stateList = states;
      if (!Array.isArray(stateList) || stateList.length === 0) {
        stateList = await fetchAllStates();
      }

      const matchedState = findByName(
        stateList,
        ["stateName", "name"],
        stateName,
      );
      if (!matchedState?._id) {
        pincodeLookupRef.current.lastFetched = pinCode;
        return;
      }

      setValue("state", matchedState._id, {
        shouldValidate: true,
        shouldDirty: true,
      });

      const [regionRes, districtRes] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_BASE_URL}/state/${matchedState._id}/region`,
          {
            signal: controller.signal,
            timeout: 6000,
          },
        ),
        axios.get(
          `${process.env.REACT_APP_BASE_URL}/state/${matchedState._id}/district`,
          {
            signal: controller.signal,
            timeout: 6000,
          },
        ),
      ]);
      if (requestId !== pinLookupRequestIdRef.current) return;

      const regionList = regionRes?.data?.data ?? regionRes?.data ?? [];
      const normalizedRegions = Array.isArray(regionList) ? regionList : [];
      setRegions(normalizedRegions);

      const matchedRegion = findByName(
        normalizedRegions,
        ["regionName", "name"],
        regionName,
      );
      if (matchedRegion?._id) {
        setValue("region", matchedRegion._id, {
          shouldValidate: true,
          shouldDirty: true,
        });
      }

      const districtList = districtRes?.data?.data ?? districtRes?.data ?? [];
      const normalizedDistricts = Array.isArray(districtList)
        ? districtList
        : [];
      setDistricts(normalizedDistricts);

      const matchedDistrict = findByName(
        normalizedDistricts,
        ["districtName", "name"],
        districtName,
      );
      if (!matchedDistrict?._id) {
        pincodeLookupRef.current.lastFetched = pinCode;
        return;
      }

      setValue("district", matchedDistrict._id, {
        shouldValidate: true,
        shouldDirty: true,
      });

      const talukaList = await fetchTalukas(matchedDistrict._id);
      if (requestId !== pinLookupRequestIdRef.current) return;
      const matchedTaluka = findByName(
        talukaList,
        ["talukaName", "name"],
        talukaName,
      );
      if (matchedTaluka?._id) {
        setValue("taluka", matchedTaluka._id, {
          shouldValidate: true,
          shouldDirty: true,
        });

        const villageList = await fetchVillages(matchedTaluka._id);
        if (requestId !== pinLookupRequestIdRef.current) return;
        const matchedVillage = findByName(
          villageList,
          ["villageName", "name"],
          villageName,
        );
        if (matchedVillage?._id) {
          setValue("village", matchedVillage._id, {
            shouldValidate: true,
            shouldDirty: true,
          });
        }
      }

      pincodeLookupRef.current.lastFetched = pinCode;
    } catch (err) {
      if (axios.isCancel?.(err) || err?.name === "CanceledError") return;
      console.error("Error auto-fetching location from pincode:", err);
    }
  };

  useEffect(() => {
    if (mode === "view" || mode === "update") {
      const fetchUserData = async () => {
        try {
          setLoading(true);
          let userId = id;
          if (!userId) userId = localStorage.getItem("userId");
          const normalizedUserId = String(userId || "")
            .trim()
            .toLowerCase();
          if (
            !normalizedUserId ||
            normalizedUserId === "null" ||
            normalizedUserId === "undefined"
          ) {
            return;
          }

          const res = await ApiCallService.get(
            `${process.env.REACT_APP_BASE_URL}/user/${userId}`,
          );
          setUserForVefication(res);
          const user = res;

          // Initialize taluka and village lists outside conditional so they're available for all modes
          let talukaList = [];
          let villageList = [];

          // In view mode, load dependent location lists once so read-only selects can show labels.
          if (mode !== "view") {
            await fetchCountries(); // ensures countries list is present
            if (mode === "update") {
              await fetchAllStates();
            } else {
              await fetchStatesByCountry(user.Country?._id);
            }

            if (user.State?._id) await fetchDistricts(user.State._id);

            // await fetchTalukas/fetchVillages and capture returned arrays so we can fallback by name match
            talukaList = user.District?._id
              ? await fetchTalukas(user.District._id)
              : [];
            villageList = user.Taluka?._id
              ? await fetchVillages(user.Taluka._id)
              : [];
          } else {
            await fetchCountries();
            await fetchAllStates();
            if (user.State?._id) {
              const [regionRes, districtRes] = await Promise.all([
                axios.get(
                  `${process.env.REACT_APP_BASE_URL}/state/${user.State._id}/region`,
                ),
                axios.get(
                  `${process.env.REACT_APP_BASE_URL}/state/${user.State._id}/district`,
                ),
              ]);
              setRegions(regionRes?.data?.data ?? regionRes?.data ?? []);
              setDistricts(districtRes?.data?.data ?? districtRes?.data ?? []);
            }
            talukaList = user.District?._id
              ? await fetchTalukas(user.District._id)
              : [];
            villageList = user.Taluka?._id
              ? await fetchVillages(user.Taluka._id)
              : [];
          }

          // helper: find option.value by matching label (case-insensitive) or value
          const mapOptionValue = (options, apiVal) => {
            if (!apiVal) return "";
            const lower = String(apiVal).toLowerCase();
            // exact label/value match first
            const byLabel = options.find(
              (o) => String(o.label || "").toLowerCase() === lower,
            );
            if (byLabel) return byLabel.value;
            const byValue = options.find(
              (o) => String(o.value || "").toLowerCase() === lower,
            );
            if (byValue) return byValue.value;
            // partial / substring matches (helpful when API returns "PostgraduateCertification" etc.)
            const byLabelPartial = options.find(
              (o) =>
                String(o.label || "")
                  .toLowerCase()
                  .includes(lower) ||
                lower.includes(String(o.label || "").toLowerCase()),
            );
            if (byLabelPartial) return byLabelPartial.value;
            return "";
          };

          const maritalOptions = [
            { value: "single", label: "Single" },
            { value: "married", label: "Married" },
            { value: "widowed", label: "Widowed" },
            { value: "divorced", label: "Divorced" },
            { value: "separated", label: "Separated" },
            { value: "other", label: "Other" },
          ];
          const educationOptions = [
            { value: "primary", label: "Primary" },
            { value: "secondary", label: "Secondary" },
            { value: "highersecondary", label: "Higher Secondary" },
            { value: "graduate", label: "Graduate" },
            { value: "postgraduate", label: "Postgraduate" },
            { value: "doctorate", label: "Doctorate" },
            { value: "other", label: "Other" },
          ];

          const mappedMarital = mapOptionValue(
            maritalOptions,
            user.maritalStatus,
          );
          const mappedEducation = mapOptionValue(
            educationOptions,
            user.Education,
          );

          // taluka/village fallback: if API gave nested object with name but our fetched lists don't include _id,
          // try to match by name to find the correct _id to preselect.
          const findTalukaId = () => {
            if (user.Taluka?._id) return user.Taluka._id;
            if (user.Taluka?.talukaName && Array.isArray(talukaList)) {
              const found = talukaList.find(
                (t) =>
                  String(t.talukaName || "").toLowerCase() ===
                  String(user.Taluka.talukaName || "").toLowerCase(),
              );
              return found?._id || "";
            }
            return "";
          };

          const findVillageId = () => {
            if (user.Village?._id) return user.Village._id;
            if (user.Village?.villageName && Array.isArray(villageList)) {
              const found = villageList.find(
                (v) =>
                  String(v.villageName || "").toLowerCase() ===
                  String(user.Village.villageName || "").toLowerCase(),
              );
              return found?._id || "";
            }
            return "";
          };

          const talukaId = findTalukaId();
          const villageId = findVillageId();
          const values = {
            salutation: user.salutation || user.Salutation || "",
            userFirstName: user.userFirstName || "",
            userImageURL: user.userImageURL || "",
            userDocumentVerifyURL: user.userDocumentVerifyURL || "",
            userMiddleName: user.userMiddleName || "",
            userLastName: user.userLastName || "",
            whatsAppNumber: user.whatsAppNumber || "",
            mobileNumber: user.mobileNumber || "",
            sameAsMobileNumber: user.sameAsMobileNumber || false,
            // alternateNumber: user.alternateNumber || "",
            emailId: user.emailId || "",
            gender: user.gender || "",
            // dob: user.dob ? dayjs(user.dob).format("YYYY-MM-DD") : "",
            profession: user.profession || "",
            // address: user.address || "",
            city: user.city || "",
            pinCode: user.pinCode || "",
            maritalStatus: mappedMarital || "",
            education: mappedEducation || "",
            // bjsConnectProfileID: user.BJSConnectProfileID || "",
            JoinedSince: user.userJoinDate
              ? dayjs(user.userJoinDate).format("YYYY")
              : "",
            country: user.Country?._id || "",
            state: user.State?._id || "",
            region: user.Region?._id || "",
            district: user.District?._id || "",
            taluka: talukaId || "",
            village: villageId || "",
            pinCode: user.pinCode || "",
            userRole: user?.userRole || "",
          };

          // set local image/url states used outside react-hook-form
          setImageURL(getPublicS3Url(user.userImageURL || ""));
          setImageKey(
            typeof user.userImageURL === "string" &&
              !/^https?:\/\//i.test(user.userImageURL)
              ? user.userImageURL
              : "",
          );
          setIdUrl(getPublicS3Url(user.userDocumentVerifyURL || ""));
          setIdKey(
            typeof user.userDocumentVerifyURL === "string" &&
              !/^https?:\/\//i.test(user.userDocumentVerifyURL)
              ? user.userDocumentVerifyURL
              : "",
          );

          // reset the form with populated values after master lists loaded
          reset(values);
          // also keep formData for any non-hook-form usage
          setFormData(values);
          if (mode === "update" && user.State?._id) {
            setValue("state", user.State._id, {
              shouldDirty: false,
              shouldTouch: false,
              shouldValidate: false,
            });
          }
          const userCommittees = await ApiCallService.get(
            `${process.env.REACT_APP_BASE_URL}/user/committeeUser/${userId}`,
          );
          const comm =
            userCommittees?.data?.data?.committees ||
            userCommittees?.data?.committees ||
            userCommittees?.committees ||
            [];
          const rows = comm.map((c) => ({
            council: c.council?._id || "",
            committeeState: "",
            committeeStates: [],
            committees: c?._id
              ? [
                  {
                    _id: c._id,
                    name: c.name || c.committeeName || "",
                    designations: Array.isArray(c.designations)
                      ? c.designations
                      : [],
                  },
                ]
              : [],
            committee: c._id, // selected committee
            designations:
              c.designations?.map((d) =>
                typeof d === "string" ? d : d?._id || d?.id || "",
              ) || [],
            designationOptions:
              c.designations?.map((d) => ({
                _id: typeof d === "string" ? d : d?._id || d?.id || "",
                title:
                  (typeof d === "string"
                    ? ""
                    : d?.title || d?.name || d?.label) ||
                  (typeof d === "string" ? d : d?._id || d?.id || ""),
              })) || [],
            designationScopes: {},
            designationPrivileges: {},
            hasLoadedCommitteeOptions: false,
            hasLoadedDesignationOptions: false,
          }));

          recordInitialCommitteeMemberships(rows);
          setCommitteeRows(rows);
          if (rows.length > 0) {
            setAuthorityType((prev) =>
              Array.from(new Set([...(prev || []), "COMMITTEE"])),
            );
          }
        } catch (err) {
          console.error("Error fetching user details:", err);
        } finally {
          setLoading(false);
        }
      };

      fetchUserData();
    }
  }, [mode, id]);

  useEffect(() => {
    if (mode !== "create") return;

    const initCreateMode = async () => {
      try {
        setLoading(true);

        await fetchCountries();
        await fetchAllStates();

        const existingMobile = getValues("mobileNumber");

        if (!existingMobile) {
          const emptyValues = getEmptyFormValues();
          reset(emptyValues);
          setFormData(emptyValues);
        }

        setImageURL("");
        setImageKey("");
        setIdUrl("");
        setIdKey("");
        resetAssignmentsForCreate();
        setSelectedUser(null);
        setDuplicateUsers([]);
        setUserForVefication({});
      } catch (err) {
        console.error("Error initializing create mode:", err);
      } finally {
        setLoading(false);
      }
    };

    initCreateMode();
  }, [mode]);

  useEffect(() => {
    if (userData?.error === "User not found.") setOpenPopup(true);
  }, [userData]);

  useEffect(() => {
    const path = location.pathname;

    const isSelfRegistration = path.includes("/registerNewUser");
    const isAdminCreate = path.includes("/committee/registerNewUser");

    if (isSelfRegistration && !isAdminCreate) {
      const storedMobile = localStorage.getItem("mobileNumber");
      // so now mobile number is only stored when we are in create new user.

      if (storedMobile) {
        setValue("mobileNumber", storedMobile, { shouldValidate: true });
        checkIfUserAlreadyExists(storedMobile);
      }
    }

    // Skip country fetch in view mode - not needed for read-only display
    if (mode !== "view") {
      fetchCountries();
    }
  }, [mode]);

  const shouldWaitForData =
    (mode === "update" || mode === "view") && !formData?.mobileNumber;


  async function fetchCountries() {
    try {
      setLoading(true);
      let response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/countrys`,
      );
      const resCountry = response.data;
      setCountries(resCountry);

      if (resCountry) {
        resCountry.forEach((country) => {
          if (country.countryName === "India") setIndiaObject(country);
        });
      }
    } catch (err) {
      toast.error("Error occured while fetching the countries.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (indiaObject._id) setValue("country", "676a5efa74f99238834a5c4c");
    // eslint-disable-next-line
  }, [indiaObject]);

  // Dependent dropdowns
  useEffect(() => {
    // Skip API calls in view mode - form is read-only
    if (mode === "view") return;

    const prevState = prevStateRef.current;
    if (!stateValue) {
      setRegions([]);
      setDistricts([]);
      setTalukas([]);
      setVillages([]);
      setValue("region", "");
      setValue("district", "");
      setValue("taluka", "");
      setValue("village", "");
      prevStateRef.current = "";
      return;
    }

    if (prevState && prevState !== stateValue) {
      setValue("region", "");
      setValue("district", "");
      setValue("taluka", "");
      setValue("village", "");
      setTalukas([]);
      setVillages([]);
    }

    prevStateRef.current = stateValue;
    (async () => {
      setLoading(true);
      try {
        const [regionRes, districtRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_BASE_URL}/state/${stateValue}/region`,
          ),
          axios.get(
            `${process.env.REACT_APP_BASE_URL}/state/${stateValue}/district`,
          ),
        ]);
        setRegions(regionRes?.data?.data ?? regionRes?.data ?? []);
        setDistricts(districtRes?.data?.data ?? districtRes?.data ?? []);
      } catch (err) {
        console.error("Error fetching regions/districts:", err);
        showNotification("Error fetching Regions/Districts.", "warning");
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateValue, mode]);

  useEffect(() => {
    // Skip cascading updates in view mode - form is read-only
    if (mode === "view") return;

    const prevRegion = prevRegionRef.current;
    if (!regionValue) {
      setValue("district", "");
      setValue("taluka", "");
      setValue("village", "");
      setTalukas([]);
      setVillages([]);
      prevRegionRef.current = "";
      return;
    }

    if (prevRegion && prevRegion !== regionValue) {
      setValue("district", "");
      setValue("taluka", "");
      setValue("village", "");
      setTalukas([]);
      setVillages([]);
    }

    prevRegionRef.current = regionValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regionValue, mode]);

  useEffect(() => {
    // Skip API calls in view mode - form is read-only
    if (mode === "view") return;

    const prevDistrict = prevDistrictRef.current;
    if (!districtValue) {
      setTalukas([]);
      setVillages([]);
      setValue("taluka", "");
      setValue("village", "");
      prevDistrictRef.current = "";
      return;
    }

    if (prevDistrict && prevDistrict !== districtValue) {
      setValue("taluka", "");
      setValue("village", "");
      setTalukas([]);
      setVillages([]);
    }

    prevDistrictRef.current = districtValue;
    (async () => {
      try {
        await fetchTalukas(districtValue);
      } catch (err) {
        console.error(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districtValue, mode]);

  useEffect(() => {
    // Skip API calls in view mode - form is read-only
    if (mode === "view") return;

    const prevTaluka = prevTalukaRef.current;
    if (!talukaValue) {
      setVillages([]);
      setValue("village", "");
      prevTalukaRef.current = "";
      return;
    }

    if (prevTaluka && prevTaluka !== talukaValue) {
      setValue("village", "");
      setVillages([]);
    }

    prevTalukaRef.current = talukaValue;
    (async () => {
      try {
        await fetchVillages(talukaValue);
      } catch (err) {
        console.error(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [talukaValue, mode]);

  useEffect(() => {
    if (!validatePincode(pinCodeValue || "")) return;
    if (pinLookupDebounceRef.current) {
      clearTimeout(pinLookupDebounceRef.current);
    }
    pinLookupDebounceRef.current = setTimeout(() => {
      autoFillLocationFromPinCode(pinCodeValue);
    }, 450);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinCodeValue, mode]);

  useEffect(() => {
    return () => {
      if (pinLookupDebounceRef.current) {
        clearTimeout(pinLookupDebounceRef.current);
      }
      if (pinLookupAbortRef.current) {
        pinLookupAbortRef.current.abort();
      }
    };
  }, []);

  const mobileNumber = watch("mobileNumber");

  // useEffect(() => {
  //   if (sameAsMobile) {
  //     prevWhatsAppRef.current = getValues("whatsAppNumber") || "";
  //     setValue("whatsAppNumber", mobileNumber || "", {
  //       // shouldValidate: true,
  //     });
  //   } else {
  //     setValue("whatsAppNumber", prevWhatsAppRef.current || "", {
  //       // shouldValidate: true,
  //     });
  //   }
  // }, [mobileNumber, sameAsMobile]);

  useEffect(() => {
    if (sameAsMobile) {
      // While ON, WhatsApp mirrors current mobile value.
      setValue("whatsAppNumber", mobileNumber || "", {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  }, [mobileNumber, sameAsMobile, setValue]);

  // File upload handlers
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/upload/document/image`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      const res = response.data;
      setImageURL(getPublicS3Url(res.document || res.key || ""));
      setImageKey(res.key || "");
      setValue("userImageURL", res.key || res.document || "", {
        shouldValidate: true,
      });
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } catch (err) {
      console.log("upload err full", err);
      console.log("upload err response", err?.response?.data);
      showNotification(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Error uploading image.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDocumentUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/upload/document/image`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      const res = response.data;
      setIdUrl(getPublicS3Url(res.document || res.key || ""));
      setIdKey(res.key || "");
      setValue("userDocumentVerifyURL", res.key || res.document || "", {
        shouldValidate: true,
      });
    } catch (err) {
      showNotification("Error uploading image.", "error");
    } finally {
      setLoading(false);
    }
  };

  // User duplicate check
  const checkIfUserAlreadyExists = async (mobileNumber) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/user?mobileNumber=${mobileNumber}`,
      );

      const data = res.data;
      if (data.documents && data.documents.length > 0) {
        if (data.documents.length === 1) {
          reset(data.documents[0]);
        } else {
          //****** NEED TO HANDLE MULTIPLE DUPLICATES LATER
          setDuplicateUsers(data.documents);
          setSelectedUser(data.documents[0]);
          reset(data.documents[0]);
        }
      } else if (!data.documents && !data.error) {
        reset(data);
      } else if (data.error) {
        console.log("No user found, proceed with registration.");
        reset({});
        setDuplicateUsers([]);
        setSelectedUser(null);
        setOpenRegisterDialog(true);
      }
    } catch (err) {
      setFormData({});
      setDuplicateUsers([]);
      setSelectedUser(null);
      showNotification(
        "Something went wrong while fetching user data.",
        "error",
      );
    }
  };

  // Validation rules
  const fieldRules = {
    userFirstName: {
      required: "Please enter your first name.",
      pattern: {
        value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
        message: "First name must contain only alphabets and spaces.",
      },
    },
    userLastName: {
      required: "Please enter your last name.",
      pattern: {
        value: /^[A-Za-z]+$/,
        message: "Last name must contain only alphabets.",
      },
    },
    userMiddleName: {
      pattern: {
        value: /^[A-Za-z]*$/,
        message: "Middle name must contain only alphabets.",
      },
    },
    whatsAppNumber: {
      required: "Please enter your WhatsApp number.",
      validate: (v) =>
        validateMobile(v) || "Mobile number must be exactly 10 digits.",
    },
    mobileNumber: {
      required: "Please enter your Mobile number.",
      validate: (v) =>
        validateMobile(v) || "Mobile number must be exactly 10 digits.",
    },
    // alternateNumber: {
    //   validate: (v) =>
    //     !v || validateMobile(v) || "Mobile number must be exactly 10 digits.",
    // },
    // emailId: {
    //   required: "Please enter your e-mail.",
    //   validate: (v) => !v || validateEmail(v) || "Invalid email format.",
    // },
    // dob: {
    //   // required: "DOB cannot be empty.",
    //   validate: (v) => {
    //     // if (!v) return "DOB cannot be empty.";
    //     // if (!validateDob(v)) return "Invalid date format. Use YYYY-MM-DD.";
    //     if (dayjs(v).isAfter(dayjs().subtract(18, "year")))
    //       return "Please enter a valid date of birth.";
    //     return true;
    //   },
    // },
    profession: {
      validate: (v) =>
        !v ||
        validateProfession(v) ||
        "Enter your profession (e.g., Doctor, Engineer, Professor).",
    },
    // pinCode: {
    //   required: "Please enter your Pincode.",
    //   validate: (v) =>
    //     validatePincode(v) || "Pincode must be exactly 6 digits.",
    // },
    // address: {
    //   validate: (v) =>
    //     !v || v.trim().length >= 5 || "Address must be at least 5 characters.",
    // },
    city: {
      validate: (v) =>
        !v || /^[A-Za-z\s]+$/.test(v) || "City must contain only alphabets.",
    },
    gender: { required: "Please enter your gender." },
    state: { required: "Please enter your State." },
    region: { required: false },
    district: { required: false },
    taluka: { required: false },
    village: { required: false },
    // region: { required: "Please enter your Region." },
    // district: { required: "Please enter your District." },
    // taluka: { required: "Please enter your Taluka." },              // to be uncommented in future
    // village: { required: "Please enter your Village." },
    userImageURL: { required: "Please upload your profile image." },
    userDocumentVerifyURL: { required: "Please upload your documents." },
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 71 }, (_, i) => {
    const y = currentYear - i;
    return { value: String(y), label: String(y) };
  });

  const persistAssignmentsForUser = async (targetUserId) => {
    const errors = await runAssignments(targetUserId);
    const userAssignmentsError = await syncUserAssignments(targetUserId);
    const combinedErrors = [...errors];
    if (userAssignmentsError) combinedErrors.push(userAssignmentsError);
    setAssignmentErrors(combinedErrors);
    setLastAssignedUserId(targetUserId);
    return combinedErrors;
  };

  // Form submit
  const onSubmit = async (data) => {
    try {
      const resolvedSameAsMobile =
        typeof data.sameAsMobileNumber === "boolean"
          ? data.sameAsMobileNumber
          : Boolean(sameAsMobile);
      const canAutoVerifyOnCreate =
        mode === "create" && !isSelfService && canApproveUserCreate;

      const normalizeSubmittedValue = (val) => {
        if (val === null || val === undefined || val === "") return "";
        if (typeof val === "string") return val.trim();
        return String(val);
      };
      const submittedSalutation = normalizeSubmittedValue(data.salutation);
      const existingSalutation = normalizeSubmittedValue(
        userForVefication?.salutation || userForVefication?.Salutation,
      );
      const hasSalutationChange =
        mode === "update" && submittedSalutation !== existingSalutation;

      // Check if profile data has actually changed (only for update mode)
      const hasProfileChanges =
        mode === "update"
          ? (() => {
              if (!userForVefication) return true; // If no existing data, assume changes
              if (hasSalutationChange) return true;

              const normalizeValue = (val) => {
                if (val === null || val === undefined || val === "") return "";
                if (typeof val === "string") return val.trim();
                return String(val);
              };

const normalizeMediaValue = (val) => {

  if (!val) return "";

  let value = getPublicS3Url(val);

  // Remove S3 base URL
  value = value.replace(
    "https://vmsprojectdata.s3.ap-south-1.amazonaws.com/",
    ""
  );

  // Decode URL encoded characters
  value = decodeURIComponent(value);

  return value.trim();
};

              const normalizeYearValue = (val) => {
                if (!val) return "";
                const parsed = dayjs(val);
                return parsed.isValid()
                  ? parsed.format("YYYY")
                  : normalizeValue(val);
              };

              const getExistingValue = (...fieldNames) =>
                normalizeValue(
                  fieldNames.reduce((current, fieldName) => {
                    if (
                      current !== null &&
                      current !== undefined &&
                      current !== ""
                    ) {
                      return current;
                    }
                    return userForVefication?.[fieldName];
                  }, undefined),
                );

              const fieldsToCompare = [
                {
                  form: data.userFirstName,
                  existing: getExistingValue("userFirstName"),
                },
                {
                  form: data.userMiddleName,
                  existing: userForVefication.userMiddleName,
                },
                {
                  form: data.userLastName,
                  existing: userForVefication.userLastName,
                },
                {
                  form: data.whatsAppNumber,
                  existing: userForVefication.whatsAppNumber,
                },
                {
                  form: Boolean(resolvedSameAsMobile),
                  existing: Boolean(userForVefication.sameAsMobileNumber),
                },
                { form: data.emailId, existing: userForVefication.emailId },
                { form: data.gender, existing: userForVefication.gender },
                {
                  form: data.profession,
                  existing: userForVefication.profession,
                },
                // { form: data.address, existing: userForVefication.address },
                { form: data.city, existing: userForVefication.city },
                {
                  form: data.maritalStatus,
                  existing: userForVefication.maritalStatus,
                },
                { form: data.education, existing: userForVefication.Education },
                {
                  form: normalizeYearValue(data.JoinedSince),
                  existing: normalizeYearValue(
                    userForVefication.userJoinDate ||
                      userForVefication.JoinDate,
                  ),
                },
                { form: data.state, existing: userForVefication.State?._id },
                { form: data.region, existing: userForVefication.Region?._id },
                {
                  form: data.district,
                  existing: userForVefication.District?._id,
                },
                { form: data.taluka, existing: userForVefication.Taluka?._id },
                {
                  form: data.village,
                  existing: userForVefication.Village?._id,
                },
                { form: data.pinCode, existing: userForVefication.pinCode },
                {
                  form: normalizeMediaValue(
                    imageKey || data.userImageURL || imageURL,
                  ),
                  existing: normalizeMediaValue(userForVefication.userImageURL),
                },
                {
                  form: normalizeMediaValue(
                    idKey || data.userDocumentVerifyURL || idURL,
                  ),
                  existing: normalizeMediaValue(
                    userForVefication.userDocumentVerifyURL,
                  ),
                },
              ];

            
              // Compare other fields
           fieldsToCompare.forEach(({ form, existing }, index) => {
  const normalizedForm = normalizeValue(form);
  const normalizedExisting = normalizeValue(existing);

});

return fieldsToCompare.some(({ form, existing }) => {
  return normalizeValue(form) !== normalizeValue(existing);
});
            })()
          : true; // For create mode, always process profile

      const shouldProcessProfile =
        mode === "create" || (mode === "update" && hasProfileChanges);
      const shouldProcessAssignments =
        mode !== "view" &&
        shouldRenderAssignmentsSection &&
        canEditAssignments &&
        hasAssignmentChanges;
      const hasAnyChangesToProcess =
        shouldProcessProfile || shouldProcessAssignments;

      if (mode === "update" && !hasAnyChangesToProcess) {
        showNotification("No changes for updation.", "warning");
        return;
      }

      if (shouldProcessAssignments) {
        const assignmentError = validateAssignments();
        if (assignmentError) {
          showNotification(assignmentError, "warning");
          return;
        }
      }

      setLoading(true);

      const userPayload = {
        salutation: submittedSalutation,
        Salutation: submittedSalutation,
        userFirstName: data.userFirstName,
        userImageURL: imageKey || imageURL || data.userImageURL,
        userDocumentVerifyURL: idKey || idURL || data.userDocumentVerifyURL,
        userMiddleName: data.userMiddleName,
        userLastName: data.userLastName,
        whatsAppNumber: data.whatsAppNumber,
        mobileNumber: Number(data.mobileNumber),
        sameAsMobileNumber: Boolean(resolvedSameAsMobile),
        emailId: data.emailId,
        gender: data.gender,
        // dob: new Date(data.dob) || "",
        profession: data.profession,
        // address: data.address,
        city: data.city,
        maritalStatus: data.maritalStatus,
        Education: data.education,
        // BJSConnectProfileID: data.bjsConnectProfileID,
        JoinDate: data.JoinedSince,
        Country: "676a5efa74f99238834a5c4c",
        State: data.state,
        Region: data.region,
        District: data.district,
        Taluka: data.taluka,
        Village: data.village,
        pinCode: data.pinCode,
        userRole: data.userRole,
        updatedBy: loggedInUser,
        verified: canAutoVerifyOnCreate ? "verified" : undefined,
        filledBy,
        filledByUserId: filledBy === "HO" ? userIdDetails.userId : null,
      };

      let savedUserId = id;

      if (shouldProcessProfile && mode === "create") {
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/user`,
          userPayload,
        );
        savedUserId = res.data.user._id;
      } else if (shouldProcessProfile && mode === "update") {
        try {
          // alert("this API fired the patch one.")
          setLoading(true);
          let res = await ApiCallService.patch(
            `${process.env.REACT_APP_BASE_URL}/${id}/profileUpdate`,
            userPayload,
          );
          // message.success(res?.message );
          showNotification(res?.message);

          const isOwnProfile = String(loggedInUser) === String(id);
          if (isOwnProfile) {
            const latestUserDetails = await ApiCallService.get(
              `${process.env.REACT_APP_BASE_URL}/user/${id}`,
            );
            dispatch(updateUserDetails(latestUserDetails));
            localStorage.setItem(
              "userDetails",
              JSON.stringify(latestUserDetails),
            );
          }
        } catch (err) {
          setLoading(false);
          const apiErrorMessage = getApiErrorMessage(err);
          if (
            typeof apiErrorMessage === "string" &&
            apiErrorMessage.toLowerCase().includes("no changes detected")
          ) {
            showNotification("No changes for updation.", "warning");
          } else {
            showNotification(apiErrorMessage, "error");
          }
          return;
        }
      }

      if (shouldProcessAssignments) {
        const targetUserId = savedUserId || assignmentTargetUserId;
        if (!targetUserId) {
          showNotification(
            "Please submit profile first, then update assignments.",
            "warning",
          );
          return;
        }

        const assignmentErrors = await persistAssignmentsForUser(targetUserId);
        if (assignmentErrors.length > 0) {
          showNotification("Some assignments failed. Please retry.", "warning");
          return;
        }
      }

      const updateSuccessMessage =
        shouldProcessAssignments && !shouldProcessProfile
          ? "Assignments updated successfully"
          : shouldProcessAssignments
            ? isSelfService
              ? "Update request submitted; assignments updated successfully"
              : canEditUser
                ? "Profile and assignments updated successfully"
                : "Profile submitted for admin approval; assignments updated successfully"
            : isSelfService
              ? "Update request submitted"
              : canEditUser
                ? "Profile updated successfully"
                : "Profile submitted for admin approval";

      showNotification(
        `${
          mode === "update"
            ? updateSuccessMessage
            : canAutoVerifyOnCreate
              ? "User verified and submitted successfully"
              : isSelfService
                ? "Registration request submitted"
                : "Registration successful"
        }`,
        "success",
      );

      setTimeout(() => {
        const isNonRegisteredSelfRegistration =
          mode === "create" &&
          isSelfService &&
          (path === "/registerNewUser" || path === "/dastak/registerNewUser");

        if (isNonRegisteredSelfRegistration) {
          toast.success("Registration request submitted successfully.");
          navigate(isDastak ? "/dastak/landingPage" : "/");
        } else {
          navigate("/dashboard"); //<----------------------------------
        }
      }, 3000);
    } catch (err) {
      console.log("Error Found At:", err.response?.data || err);
      showNotification(getApiErrorMessage(err), "error");
    } finally {
      setLoading(false);
    }
  };

  const eligibleCertificateOptions = useMemo(
    () => getEligibleCertificateOptions(committeeRows, councils),
    [committeeRows, councils],
  );

  const canDownloadCommitteeCertificate =
    mode === "view" && isViewAccountSource;

  const openCertificateDialog = () => {
    if (!isViewAccountSource) {
      showNotification(
        "Certificate download is available from View Account.",
        "warning",
      );
      return;
    }
    if (eligibleCertificateOptions.length === 0) {
      showNotification(
        "Certificate is available only for eligible NEC/SEC/REC/DEC committee designations.",
        "warning",
      );
      return;
    }
    setSelectedCertificateOptionKey(eligibleCertificateOptions[0].key);
    setCertificatePreviewUrl("");
    setCertificatePreviewScale(1.5);
    setCertificateDialogOpen(true);
  };

  const buildCertificateForOption = useCallback(
    async (selectedOption) => {
      const statePresidentDetails = await resolveStatePresidentDetails({
        userForVefication,
        preferredStateId: selectedOption?.committeeStateId,
        getFallbackStateId: () => getValues("state"),
        axios,
        baseUrl: process.env.REACT_APP_BASE_URL,
      });

      return buildCertificateCanvas({
        selectedOption,
        userForVefication,
        templateSrc: certificateTemplate,
        founderSignSrc: FOUNDER_SIGN_PATH,
        nationalPresidentSignSrc: NATIONAL_PRESIDENT_SIGN_PATH,
        founderName: FOUNDER_NAME,
        nationalPresidentName: NATIONAL_PRESIDENT_NAME,
        tenureText: TENURE_TEXT,
        statePresidentDetails,
      });
    },
    [getValues, userForVefication],
  );

  useEffect(() => {
    if (!certificateDialogOpen || !selectedCertificateOptionKey) return;
    const selectedOption = eligibleCertificateOptions.find(
      (item) => item.key === selectedCertificateOptionKey,
    );
    if (!selectedOption) return;

    let cancelled = false;
    const loadPreview = async () => {
      try {
        setCertificatePreviewLoading(true);
        const { canvas } = await buildCertificateForOption(selectedOption);
        if (cancelled) return;
        setCertificatePreviewUrl(canvas.toDataURL("image/png"));
      } catch (e) {
        if (!cancelled) setCertificatePreviewUrl("");
      } finally {
        if (!cancelled) setCertificatePreviewLoading(false);
      }
    };
    loadPreview();
    return () => {
      cancelled = true;
    };
  }, [
    buildCertificateForOption,
    certificateDialogOpen,
    selectedCertificateOptionKey,
    eligibleCertificateOptions,
  ]);

  const handleDownloadAppointmentCertificate = async () => {
    const selectedOption = eligibleCertificateOptions.find(
      (item) => item.key === selectedCertificateOptionKey,
    );
    if (!selectedOption) {
      showNotification(
        "Please select a designation to download certificate.",
        "warning",
      );
      return;
    }
    try {
      setCertificateLoading(true);
      const { canvas, fullName } =
        await buildCertificateForOption(selectedOption);
      const safeName = sanitizeFileSegment(fullName, "member");
      const safeDesignation = sanitizeFileSegment(
        selectedOption.designationTitle,
        "designation",
      );
      const fileName = `BJS_${selectedOption.councilType}_${safeDesignation}_${safeName}.pdf`;
      await downloadCanvasAsPdf(canvas, fileName);
      await ApiCallService.post(
        `${process.env.REACT_APP_BASE_URL}/committeeMembers/certificate-download-log`,
        {
          userId: id || userForVefication?._id,
          committeeId: selectedOption.committeeId,
          designationId: selectedOption.designationId,
          councilType: selectedOption.councilType,
          councilName: selectedOption.councilName,
          committeeName: selectedOption.committeeName,
          designationTitle: selectedOption.designationTitle,
          fileName,
        },
      );
      showNotification("Certificate downloaded successfully.", "success");
      setCertificateDialogOpen(false);
    } catch (err) {
      showNotification(
        err?.message || "Failed to download certificate.",
        "error",
      );
    } finally {
      setCertificateLoading(false);
    }
  };

  const isUpdate = Boolean(id);
  const disableInUpdateModeFields = new Set(["mobileNumber"]);

  const handleVerify = async (id) => {
    const loginUserId = await localStorage.getItem("userId");
    setLoading(true);
    try {
      const res = await ApiCallService.patch(
        `${process.env.REACT_APP_BASE_URL}/user/verifyuser/${id}`,
        loginUserId,
      );
      // setUser(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Error verifying user:", error);
      showNotification("Error verifying user", "error");
      //  setError("Error Occured", error);
    } finally {
      showNotification("User successfully verified.", "success");
      //  fetchUserDetails();
      setTimeout(() => {
        navigate(-1); // navigate(-1) will take the user back to the previous page
      }, 3000);
    }
  };

  const handleDecline = async (id) => {
    const loginUserId = localStorage.getItem("userId");
    setLoading(true);
    try {
      const res = await ApiCallService.patch(
        `${process.env.REACT_APP_BASE_URL}/user/declineuser/${id}`,
        { loginUserId },
      );
      // setUser(res.user);
      showNotification("User successfully declined.", "success");
      //  fetchUserDetails();
      setTimeout(() => navigate(-1), 3000);
    } catch (error) {
      console.error("Error declining user:", error);
      showNotification("Error declining user", "error");
      //  setError("Error occurred", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={0} variant="pageBg">
      {loading && (
        <Box
          sx={{
            position: "fixed", // or absolute
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "#fff", // 🔥 IMPORTANT
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner loading={loading} />
        </Box>
      )}
      {/* <Box // this is commented for the time being i want to make it visible on mode === update, so when user is updating his own details he can have a option to view Journey.
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Box sx={{ width: "33%" }} />
      </Box> */}
      {mode === "view" ? (
        <Box display="flex" alignItems="center" mb={3} gap={2}>
          <Button
            variant="outlined"
            // startIcon={<ArrowBackIcon />}
            onClick={handleBack}
            sx={{ width: "fit-content", display:"flex", flexDirection:"row", gap:0.5 }}
          >
            <ArrowBackIcon />
            {!isMobile && "Back"}
          </Button>

          <Box flexGrow={1} />

          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: 600, mb: 0, textAlign: "center" }}
          >
            User Profile
          </Typography>

          <Box flexGrow={1} />

          {isMobile ? (
            <>
              <IconButton onClick={handleMenuOpen}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                style={{ border: "1px solid black" }}
              >
                {!isDesignationUsersApprovalsSource && canEditUser && (
                  <MenuItem
                    onClick={() => {
                      handleEdit();
                      handleMenuClose();
                    }}
                  >
                    Edit
                  </MenuItem>
                )}
                {!isDesignationUsersApprovalsSource &&
                  !isViewAccountSource &&
                  canViewJourney && (
                    <MenuItem
                      onClick={() => {
                        handleViewJourney();
                        handleMenuClose();
                      }}
                    >
                      Journey
                    </MenuItem>
                  )}
                {!isDesignationUsersApprovalsSource &&
                  canDownloadCommitteeCertificate && (
                    <MenuItem
                      onClick={() => {
                        openCertificateDialog();
                        handleMenuClose();
                      }}
                      disabled={certificateLoading}
                    >
                      {certificateLoading
                        ? "Downloading..."
                        : "Download Certificate"}
                    </MenuItem>
                  )}
                {canShowHeaderUserStatusAction &&
                  userForVefication?.userStatus === "active" && (
                    <MenuItem
                      onClick={() => {
                        openStatusDialog("deactivate");
                        handleMenuClose();
                      }}
                    >
                      {deactivateUserLabel}
                    </MenuItem>
                  )}
                {canShowHeaderUserStatusAction &&
                  userForVefication?.userStatus !== "active" && (
                    <MenuItem
                      onClick={() => {
                        openStatusDialog("reactivate");
                        handleMenuClose();
                      }}
                    >
                      Reactivate User
                    </MenuItem>
                  )}
                {canShowHeaderCommitteeDeactivation && (
                  <MenuItem
                    onClick={() => {
                      handleDeactivateCommitteeMemberships();
                      handleMenuClose();
                    }}
                  >
                    {deactivateCommitteeMemberLabel}
                  </MenuItem>
                )}
              </Menu>
            </>
          ) : (
            <Box sx={{ display: "flex", gap: 1, ml: 1 }}>
              {!isDesignationUsersApprovalsSource && canEditUser && !isDastak && (
                <Button
                  onClick={handleEdit}
                  size="small"
                  variant="outlined"
                  endIcon={<EditIcon/>}
                  sx={{ textTransform: "none" }}
                >
                  Edit
                </Button>
              )}
              {!isDesignationUsersApprovalsSource &&
                !isViewAccountSource &&
                canViewJourney && (
                  <Button
                    onClick={handleViewJourney}
                    size="small"
                    variant="outlined"
                    sx={{ textTransform: "none" }}
                  >
                    Journey
                  </Button>
                )}
              {!isDesignationUsersApprovalsSource &&
                canDownloadCommitteeCertificate &&
                !isDastak && (
                  <Button
                    onClick={openCertificateDialog}
                    size="small"
                    variant="outlined"
                    disabled={certificateLoading}
                    sx={{ textTransform: "none"}}
                    
                  >
                    {certificateLoading
                      ? "Downloading..."
                      : "Download Certificate"}
                  </Button>
                )}
              {canShowHeaderUserStatusAction &&
                userForVefication?.userStatus === "active" && (
                  <Button
                    onClick={() => openStatusDialog("deactivate")}
                    size="small"
                    variant="outlined"
                    color="error"
                    sx={{ textTransform: "none" }}
                  >
                    {deactivateUserLabel}
                  </Button>
                )}
              {canShowHeaderUserStatusAction &&
                userForVefication?.userStatus !== "active" && (
                  <Button
                    onClick={() => openStatusDialog("reactivate")}
                    size="small"
                    variant="outlined"
                    color="primary"
                    sx={{ textTransform: "none" }}
                  >
                    Reactivate User
                  </Button>
                )}
              {canShowHeaderCommitteeDeactivation && (
                <Button
                  onClick={handleDeactivateCommitteeMemberships}
                  size="small"
                  variant="outlined"
                  color="error"
                  sx={{ textTransform: "none" }}
                >
                  {deactivateCommitteeMemberLabel}
                </Button>
              )}
            </Box>
          )}
        </Box>
      ) : (
        <Box display="flex" alignItems="center" mb={3} gap={2}>
          {/* {mode === "update" && ( */}
            <>
              <Button
                variant="outlined"
                // startIcon={}
                onClick={handleBack}
                sx={{gap:0.5 }}
              >
                <ArrowBackIcon />
                {!isMobile && "Back"}
              </Button>
              <Box flexGrow={1} />
            </>
          {/* )} */}

          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: 600, alignSelf: "center" }}
          >
            {mode === "update" ? "Update Profile" : "Registration Form"}
          </Typography>

          <Box flexGrow={1} />
        </Box>


      )}
      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key !== "Enter") return;
          const targetTag = String(e.target?.tagName || "").toLowerCase();
          if (targetTag !== "textarea") {
            e.preventDefault();
          }
        }}
        noValidate
        autoComplete="off"
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            mt: 5,
            mb: 2,
            borderBottom: "2px solid #eee",
            pb: 1,
          }}
        >
          Personal Details
        </Typography>
        <Grid container spacing={3}>
          {duplicateUsers.length > 1 && (
            <Grid item xs={12}>
              <CustomSelect
                name="selectedUser"
                control={{
                  ...control,
                  setValue: (name, value) => {
                    const chosen = duplicateUsers.find((u) => u._id === value);
                    reset(chosen);
                  },
                }}
                label="Select User Record"
                options={duplicateUsers.map((user) => ({
                  value: user._id,
                  label: `${user.fName} ${user.lName} — ${user.mobile}`,
                }))}
                required
              />
              {/* CustomSelect is this why the dob component doesnt get updated? see no dropdowns get updated too just textfields in our form. */}
            </Grid>
          )}

          {formFields
            .filter(
              (f) =>
                !["alternateNumber", "profession", "dob"].includes(
                  f.name,
                ),
            )
            .map((field) => {
              const compactPersonalFieldGridProps = {
                salutation: { sm: 2, md: 1 },
                userFirstName: { sm: 9, md: 11 / 3 },
                userMiddleName: { sm: 6, md: 11 / 3 },
                userLastName: { sm: 6, md: 11 / 3 },
              }[field.name];

              if (field.type === "date") {
                return (
                  <Grid item xs={12} md={4} key={field.name}>
                    <CustomDatePicker
                      name={field.name}
                      control={control}
                      label={field.label}
                      required={field.required}
                      rules={fieldRules[field.name]}
                      disabled={mode === "view"}
                    />
                  </Grid>
                );
              }

              if (field.type === "select") {
                return (
                  <Grid
                    item
                    xs={12}
                    sm={compactPersonalFieldGridProps?.sm || 12}
                    md={compactPersonalFieldGridProps?.md || 4}
                    key={field.name}
                  >
                    <CustomSelect
                      name={field.name}
                      control={control}
                      label={field.label}
                      required={field.required}
                      options={field.options || []}
                      rules={fieldRules[field.name]}
                      disabled={mode === "view"}
                      formControlSx={
                        field.name === "salutation"
                          ? { minWidth: { xs: "100%", sm: 100 }, maxWidth: 140 }
                          : undefined
                      }
                    />
                  </Grid>
                );
              }
              if (field.name === "sameAsMobileNumber") {
                return null;
              }
              if (field.name === "whatsAppNumber") {
                return (
                  <Grid item xs={12} md={4} key={field.name}>
                    <Box
                      display="flex"
                      fullWidth
                      alignItems="flex-start"
                      sx={{ flexDirection: "column" }}
                    >
                      <CustomTextField
                        name={field.name}
                        control={control}
                        required={field.required}
                        label={field.label}
                        placeholder={field.placeholder}
                        type={field.type}
                        maxLength={field.maxLength}
                        rules={fieldRules[field.name]}
                        disabled={mode === "view" || sameAsMobile}
                        // Consider adding: size="small" if CustomTextField supports it
                      />
                      <FormControlLabel
                        sx={{
                          marginTop: "0px",
                          marginBottom: "0px",
                          marginLeft: "0",
                          marginRight: "0",
                          alignSelf: "flex-end",
                          ".MuiFormControlLabel-label": {
                            fontSize: 13,
                            marginBottom: 0,
                          },
                        }}
                        control={
                          <Checkbox
                            checked={
                              mode === "view"
                                ? formData.sameAsMobileNumber
                                : sameAsMobile
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              const currentMobile =
                                getValues("mobileNumber") || "";

                              if (checked) {
                                setValue("whatsAppNumber", currentMobile, {
                                  shouldDirty: true,
                                  shouldValidate: true,
                                });
                              } else {
                                setValue("whatsAppNumber", "", {
                                  shouldDirty: true,
                                  shouldValidate: true,
                                });
                              }

                              setValue("sameAsMobileNumber", checked, {
                                shouldDirty: true,
                                shouldTouch: true,
                                shouldValidate: false,
                              });
                            }}
                            disabled={mode === "view"}
                            size="small" // Good for reduced size
                            color="primary"
                            sx={{ padding: "2px" }}
                          />
                        }
                        label="Same as Mobile"
                        labelPlacement="end"
                      />
                    </Box>
                  </Grid>
                );
              }

              return (
                <Grid
                  item
                  xs={12}
                  sm={compactPersonalFieldGridProps?.sm || 12}
                  md={compactPersonalFieldGridProps?.md || 4}
                  key={field.name}
                >
                  <CustomTextField
                    name={field.name}
                    control={control}
                    label={field.label}
                    required={field.required}
                    placeholder={field.placeholder}
                    type={field.type}
                    maxLength={field.maxLength}
                    rules={fieldRules[field.name]}
                    disabled={
                      mode === "view" ||
                      (mode === "update" &&
                        disableInUpdateModeFields.has(field.name)) ||
                      (field.name === "mobileNumber" &&
                        isSelfService &&
                        !(isOwnProfile && isUpdate))
                    }
                 
                  />
                </Grid>
              );
            })}

        
       
        </Grid>

        

        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            mt: 5,
            mb: 2,
            borderBottom: "2px solid #eee",
            pb: 1,
          }}
        >
          User Location Details
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <CustomSelect
              name="state"
              control={control}
              label="Select your State"
              required
              disabled={mode === "view"}
              options={states.map((s) => ({
                value: s._id,
                label: s.stateName,
              }))}
              rules={fieldRules.state}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <CustomSelect
              name="region"
              control={control}
              label="Select your Region"
              options={regions.map((r) => ({
                value: r._id,
                label: r.regionName,
              }))}
              rules={fieldRules.region}
              disabled={regions.length === 0 || mode === "view"}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <CustomSelect
              name="district"
              control={control}
              label="Select your District"
              options={districts.map((d) => ({
                value: d._id,
                label: d.districtName,
              }))}
              rules={fieldRules.district}
              disabled={districts.length === 0 || mode === "view"}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <CustomSelect
              name="taluka"
              control={control}
              label="Select your Taluka"
              options={talukas.map((t) => ({
                value: t._id,
                label: t.talukaName,
              }))}
              rules={fieldRules.taluka}
              disabled={talukas.length === 0 || mode === "view"}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <CustomSelect
              name="village"
              control={control}
              label="Select your Village"
              options={villages.map((v) => ({
                value: v._id,
                label: v.villageName,
              }))}
              rules={fieldRules.village}
              disabled={villages.length === 0 || mode === "view"}
            />
          </Grid>
        </Grid>

        <Box mt={4}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mt: 2,
              mb: 2,
              borderBottom: "2px solid #eee",
              pb: 1,
            }}
          >
            Upload Photograph
          </Typography>

          <Box display="flex" alignItems="center" gap={2}>
            <Avatar
              src={imageURL}
              sx={{
                width: 96,
                height: 96,
                borderRadius: "25%",
                border: imageURL
                  ? "1px solid rgb(152, 152, 152)"
                  : "1px solid #bdbdbd",
                bgcolor: "#fafafa",
                cursor: imageURL ? "pointer" : "default",
              }}
            />

            <Button
              variant="outlined"
              component="label"
              disabled={mode === "view"}
              sx={{
                textTransform: "none",
                borderRadius: "6px",
                height: "40px",
              }}
            >
              {imageURL ? "Replace Photo" : "Upload Photo"}
              <input
                type="file"
                hidden
                name="profile_image"
                accept="image/*"
                disabled={mode === "view"}
                onChange={handleImageUpload}
              />
            </Button>
            {showAlert && (
              <Alert
                severity="success"
                sx={{
                  mt: 2,
                  borderRadius: "6px",
                }}
              >
                Image uploaded successfully
              </Alert>
            )}
          </Box>
          <Typography variant="caption" color="textSecondary" display="block">
            Max size: 5MB | Dimension: 3.5 cm x 4.5 cm | JPG/PNG
          </Typography>
        </Box>

        {canAddAssignmentsInCreate && !showCreateAssignments && (
          <Box mt={3}>
            <Button
              variant="outlined"
              color="primary"
              type="button"
              onClick={() => setShowCreateAssignments(true)}
              sx={{ textTransform: "none", borderRadius: "6px" }}
            >
              + Add Assignment
            </Button>
          </Box>
        )}

        {shouldRenderAssignmentsSection && (
          <AssignmentsTab
            mode={mode}
            canViewAssignments={shouldShowAssignmentsTab}
            canEditAssignments={canEditAssignments}
            canUpdateCommitteeMemberRole={canUpdateCommitteeMemberRole}
            canUpdateCommitteeMemberDetails={canUpdateCommitteeMemberDetails}
            canFilterCommitteeMembers={canFilterCommitteeMembers}
            canSearchCommitteeMembers={canSearchCommitteeMembers}
            canRemoveCommitteeAssignment={canRemoveCommitteeAssignment}
            authorityType={authorityType}
            setAuthorityType={setAuthorityType}
            authorityOpen={authorityOpen}
            setAuthorityOpen={setAuthorityOpen}
            clearCommitteeAssignments={clearCommitteeAssignments}
            clearChapterAssignments={clearChapterAssignments}
            clearProgramAssignments={clearProgramAssignments}
            committeeRows={committeeRows}
            handleCouncilChange={handleCouncilChange}
            handleCommitteeStateChange={handleCommitteeStateChange}
            handleCommitteeRegionChange={handleCommitteeRegionChange}
            handleCommitteeDistrictChange={handleCommitteeDistrictChange}
            handleCommitteeSubtypeChange={handleCommitteeSubtypeChange}
            handleCommitteeChange={handleCommitteeChange}
            handleDesignationChange={handleDesignationChange}
            handleScopeChange={handleScopeChange}
            emptyScope={EMPTY_SCOPE}
            scopeLevels={SCOPE_LEVELS}
            councils={councils}
            states={states}
            regions={regions}
            districts={districts}
            chapters={chapters}
            programs={programs}
            scopeRegionsByState={scopeRegionsByState}
            scopeDistrictsByState={scopeDistrictsByState}
            handleRemoveCommittee={handleRemoveCommittee}
            handleAddCommitteeRow={handleAddCommitteeRow}
            handleAddChapterAssignments={handleAddChapterAssignments}
            userExistingChapterAssignments={userExistingChapterAssignments}
            userAssignments={userAssignments}
            existingAssignmentColumns={EXISTING_ASSIGNMENT_COLUMNS}
            existingAssignmentRows={EXISTING_ASSIGNMENT_ROWS}
            addChapterAssignments={addChapterAssignments}
            chapterRows={chapterRows}
            programRows={programRows}
            programBaskets={programBaskets}
            handleAddProgramRow={handleAddProgramRow}
            handleRemoveProgramRow={handleRemoveProgramRow}
            handleProgramBasketChange={handleProgramBasketChange}
            handleProgramSelectionChange={handleProgramSelectionChange}
            handleProgramScopeChange={handleProgramScopeChange}
            handleChapterScopeChange={handleChapterScopeChange}
            testColumns={TESTcolumns}
            loading={loading}
          />
        )}

        {mode !== "view" && (
          <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              sx={{ px: 5, py: 1.2, borderRadius: 2, fontWeight: 600 }}
            >
              {mode === "update"
                ? isSelfService
                  ? "Update Request"
                  : canEditUser
                    ? "Update"
                    : "Request Update"
                : isSelfService
                  ? "Submit Request"
                  : canApproveUserCreate
                    ? "Verify & Submit"
                    : "Submit"}
            </Button>
            {canEditAssignments &&
              hasAssignmentChanges &&
              assignmentErrors.length > 0 &&
              lastAssignedUserId && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  type="button"
                  onClick={async () => {
                    const combinedErrors =
                      await persistAssignmentsForUser(lastAssignedUserId);
                    if (combinedErrors.length === 0) {
                      showNotification(
                        "Assignments updated successfully",
                        "success",
                      );
                      navigate(
                        path === "/registerNewUser"
                          ? isDastak
                            ? "/dastak/registerNewUser"
                            : "/"
                          : "committeeMembersList"
                      );
                    } else {
                      showNotification(
                        "Some assignments still failed. Please retry.",
                        "warning",
                      );
                    }
                  }}
                  sx={{
                    px: 5,
                    py: 1.2,
                    borderRadius: 2,
                    fontWeight: 600,
                    ml: 2,
                  }}
                >
                  Retry Assignments
                </Button>
              )}
          </Grid>
        )}
        {canShowStatusAction && (
          <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
            {userForVefication?.userStatus === "active"
              ? canDeactivateUser && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => openStatusDialog("deactivate")}
                  >
                    {deactivateUserLabel}
                  </Button>
                )
              : canActivateUser && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => openStatusDialog("reactivate")}
                  >
                    Reactivate User
                  </Button>
                )}
          </Grid>
        )}
        {!canShowStatusAction && canManageStatusInView && (
          <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
            <Typography variant="body2" color="textSecondary">
              Insufficient permission to change user status.
            </Typography>
          </Grid>
        )}
      </form>
      <Dialog
        open={openRegisterDialog}
        onClose={() => setOpenRegisterDialog(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>User Not Registered</DialogTitle>
        <DialogContent>
          <Typography>
            You are not registered in system. Please register to continue.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRegisterDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={statusDialogOpen}
        onClose={() => !statusLoading && setStatusDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {statusAction === "deactivate"
            ? "Confirm User Deactivation"
            : "Confirm User Reactivation"}
        </DialogTitle>
        <DialogContent>
          <TextField
            label={`Reason for ${
              statusAction === "deactivate" ? "deactivation" : "reactivation"
            }`}
            value={statusReason}
            onChange={(e) => setStatusReason(e.target.value)}
            fullWidth
            multiline
            minRows={3}
            required
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setStatusDialogOpen(false)}
            disabled={statusLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color={statusAction === "deactivate" ? "error" : "primary"}
            onClick={handleStatusActionConfirm}
            disabled={!statusReason.trim() || statusLoading}
          >
            {statusAction === "deactivate"
              ? "Deactivate User"
              : "Reactivate User"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={statusDialogOpenCommittee}
        onClose={() => !statusLoading && setStatusDialogOpenCommittee(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Confirm Committee Membership Deactivation</DialogTitle>
        <DialogContent>
          <TextField
            label="Reason for deactivation"
            value={statusReasonCommittee}
            onChange={(e) => setStatusReasonCommittee(e.target.value)}
            fullWidth
            multiline
            minRows={3}
            required
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setStatusDialogOpenCommittee(false)}
            disabled={statusLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleCommitteeDeactivationConfirm}
            disabled={!statusReasonCommittee.trim() || statusLoading}
          >
            Deactivate
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={certificateDialogOpen}
        onClose={() => !certificateLoading && setCertificateDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle>Download Committee Certificate</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Select designation for which certificate should be generated.
          </Typography>
          <TextField
            select
            fullWidth
            label="Committee Designation"
            value={selectedCertificateOptionKey}
            onChange={(e) => setSelectedCertificateOptionKey(e.target.value)}
            disabled={certificateLoading}
          >
            {eligibleCertificateOptions.map((opt) => (
              <MenuItem key={opt.key} value={opt.key}>
                {`${opt.councilType} - ${opt.committeeName} - ${opt.designationTitle}`}
              </MenuItem>
            ))}
          </TextField>
          <Box sx={{ mt: 2 }}>
            <Box
              sx={{
                mb: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Typography variant="subtitle2">Certificate Preview</Typography>
              <TextField
                select
                size="small"
                label="Zoom"
                value={String(certificatePreviewScale)}
                onChange={(e) =>
                  setCertificatePreviewScale(Number(e.target.value))
                }
                sx={{ width: 120 }}
              >
                <MenuItem value="1">100%</MenuItem>
                <MenuItem value="1.25">125%</MenuItem>
                <MenuItem value="1.5">150%</MenuItem>
                <MenuItem value="1.75">175%</MenuItem>
              </TextField>
            </Box>
            <Box
              sx={{
                width: "100%",
                minHeight: { xs: 380, sm: 460 },
                border: "1px solid #d6d6d6",
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f1f3f6",
                overflow: "auto",
                p: { xs: 1, sm: 2 },
              }}
            >
              {certificatePreviewLoading ? (
                <Typography variant="body2" color="text.secondary">
                  Generating preview...
                </Typography>
              ) : certificatePreviewUrl ? (
                <Box
                  component="img"
                  src={certificatePreviewUrl}
                  alt="Certificate preview"
                  sx={{
                    width: "auto",
                    height: "auto",
                    maxWidth: "100%",
                    maxHeight: { xs: 500, sm: 660 },
                    objectFit: "contain",
                    display: "block",
                    borderRadius: 1,
                    boxShadow: "0 10px 24px rgba(0, 0, 0, 0.16)",
                    backgroundColor: "#fff",
                    transform: `scale(${certificatePreviewScale})`,
                    transformOrigin: "top center",
                  }}
                />
              ) : (
                <Typography variant="body2" color="text.secondary">
                  Preview unavailable
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setCertificateDialogOpen(false)}
            disabled={certificateLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleDownloadAppointmentCertificate}
            disabled={!selectedCertificateOptionKey || certificateLoading}
          >
            {certificateLoading ? "Downloading..." : "Download PDF"}
          </Button>
        </DialogActions>
      </Dialog>
      {openAssignmentModal && selectedChapter && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "400px",
            }}
          >
            <h3>{selectedChapter.chapterName} - Assignments</h3>

            {selectedChapter.existingAssignment ? (
              <div>
                <p>
                  Assigned to:{" "}
                  {selectedChapter.existingAssignment.userName || "-"}
                </p>
                <p>
                  Role:{" "}
                  {
                    CHAPTER_ROLE_OPTIONS.find(
                      (r) =>
                        r.value === selectedChapter.existingAssignment.roleId,
                    )?.label
                  }
                </p>
              </div>
            ) : (
              <p>No existing assignments</p>
            )}

            <h4>Role Availability:</h4>
            <ul>
              {CHAPTER_ROLE_OPTIONS.map((opt) => {
                const availability =
                  selectedChapter.roleAvailability?.[opt.code];

                return (
                  <li key={opt.value}>
                    {opt.label} -{" "}
                    {availability
                      ? availability.available
                        ? "Available"
                        : `Assigned to ${availability.assignedTo.name}`
                      : "Not Checked"}
                  </li>
                );
              })}
            </ul>

            <button
              onClick={() => setOpenAssignmentModal(false)}
              style={{
                marginTop: "10px",
                padding: "6px 12px",
                border: "none",
                backgroundColor: "#1976d2",
                color: "#fff",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Avatar and Image Section */}
      <div>
        {/* Verify Button */}
        {(userForVefication.verified === "pending" ||
          userForVefication.verified === undefined) &&
          mode === "view" &&
          (isUsersApprovalsSource ||
            isDesignationUsersApprovalsSource) && (
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
              }}
            >
              {canApproveUserCreate && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleVerify(userForVefication._id)}
                >
                  Verify User
                </Button>
              )}
              {canDeclineUserCreate && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => handleDecline(userForVefication._id)}
                >
                  Decline User
                </Button>
              )}
            </div>
          )}
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={closeNotification}
        anchorOrigin={{ vertical: "middle", horizontal: "center" }}
        sx={{
          "& .MuiSnackbarContent-root": {
            minWidth: "300px",
            borderRadius: "8px",
          },
        }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={closeNotification}
          severity={snackbar.severity}
          sx={{ width: "100%", borderRadius: "8px" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default RegistrationFormNewUser;
